import { z } from 'zod';
import { IsoDatetimeToDateSchema } from './date-codecs.js';
export const UrlMetadataFetchBodySchema = z.object({
  strategy: z.enum(['cache', 'live']),
  urls: z.array(z.string().url()).min(1),
  source: z.string().optional(),
});
export type UrlMetadataFetchBody = z.infer<typeof UrlMetadataFetchBodySchema>;

export const UrlMetadataResponseSchema = z.object({
  metadata: z.record(z.string(), z.unknown()),
  errors: z.record(z.string(), z.string()),
});
export type UrlMetadataResponse = z.infer<typeof UrlMetadataResponseSchema>;

export const LinkClickBodySchema = z.object({
  url: z.string().url(),
  shortUrl: z.string().url().optional(),
  source: z.string().optional(),
  context: z.record(z.string(), z.unknown()).optional(),
});
export type LinkClickBody = z.infer<typeof LinkClickBodySchema>;

export const LinkClickResponseSchema = z.object({
  recorded: z.boolean(),
});
export type LinkClickResponse = z.infer<typeof LinkClickResponseSchema>;

export const UploadResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
    stats: z.object({
      stored: z.number().int().min(0),
      dataType: z.enum(['tweets', 'followers', 'following', 'likes', 'profile', 'directMessages']),
      total: z.number().int().min(0),
      failed: z.number().int().min(0),
      processingErrors: z
        .array(
          z.object({
            item: z.unknown().nullable(),
            error: z.string(),
            index: z.number().int(),
          })
        )
        .optional(),
    }),
  }),
  message: z.string().optional(),
  count: z.number().int().min(0).optional(),
});
export type UploadResponse = z.infer<typeof UploadResponseSchema>;

export const ImagePlaceholderResponseSchema = z.instanceof(Uint8Array);
export type ImagePlaceholderResponse = z.infer<typeof ImagePlaceholderResponseSchema>;

export const UploadFileBodySchema = z.instanceof(FormData);
export type UploadFileBody = FormData;

export const ImagePlaceholderPathParamsSchema = z.object({
  dimensions: z.string(),
});
export type ImagePlaceholderPathParams = z.infer<typeof ImagePlaceholderPathParamsSchema>;

export const UrlEmbeddabilityInputSchema = z.object({
  url: z.string().url(),
  forceRefresh: z.boolean().optional(),
});
export type UrlEmbeddabilityInput = z.infer<typeof UrlEmbeddabilityInputSchema>;

export const UrlEmbeddabilityResponseSchema = z.object({
  status: z.enum(['allow', 'deny', 'unknown']),
  canonicalUrl: z.string().url(),
  source: z.enum(['cache', 'refreshed', 'error']),
  checkedAt: IsoDatetimeToDateSchema,
  errorMessage: z.string().optional(),
});
export type UrlEmbeddabilityResponse = z.infer<typeof UrlEmbeddabilityResponseSchema>;
